"use strict";

define('view/finder.overlay',['underscore', 'marionette', 'uikit/uikit', 'uikit/elements/button', 'uikit/elements/input', 'uikit/collections/list', 'uikit/collections/table', 'uikit/mixins/component.mixin', './page.list', './empty.table', '../templates'], function (_, Mn, UIKit, ButtonView, InputView, ListView, TableView, ComponentMixin, PageListView, EmptyTableView, Templates) {
  var AddItemBtn = ButtonView.extend({
    options: _.extend({}, ButtonView.prototype.options, {
      circular: true,
      icon: 'plus',
      visible: false
    }),
    _show: function _show() {
      this.$el.css('visibility', 'visible');
    },
    _hide: function _hide() {
      this.$el.css('visibility', 'hidden');
    },
    onFirstRender: function onFirstRender() {
      var row = this.getOption('rowView');
      this.on('press', function () {
        row.triggerMethod('add');
      });
      this.listenTo(row, 'change:active', function () {
        this.visible = !!row.active;
      });
      this.listenTo(row, 'mouseenter', function () {
        this.visible = true;
      });
      this.listenTo(row, 'mouseleave', function () {
        if (!row.active) {
          this.visible = false;
        }
      });
    }
  });
  var FINDER_COLUMNS = [{
    childView: AddItemBtn,
    collapsing: true
  }];
  var FinderListItem = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'item',
    template: Templates.IRB['finder.item'],
    options: {
      text: ''
    },
    triggers: {
      'click i.icon.remove': 'remove'
    },
    onRender: function onRender() {
      this.$el.css({
        'padding': '1em'
      });
    }
  });
  var FinderList = ListView.extend({
    childView: FinderListItem
  });
  var FinderOverlay = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    className: 'ui grid',
    template: Templates.IRB['finder.overlay'],
    options: {
      entityName: 'item',
      loadAllImmediately: false,
      allTermsMatch: false,
      headerText: 'Added Members',
      localQuery: false
    },
    update: {
      entityName: false,
      loadAllImmediately: false,
      allTermsMatch: false,
      headerText: false,
      localQuery: false
    },
    internalViews: {
      searchList: PageListView,
      addedList: FinderList
    },
    internalViewOptions: {
      searchList: {
        visualsearch: false,
        header: false,
        useTableHeader: true,
        tableHeaderText: 'search results',
        hideTableHeaderFromScreens: true,
        tableHeaderLevel: '3'
      },
      addedList: {
        divided: true,
        childViewOptions: {
          bindings: {
            text: 'displayName'
          }
        }
      }
    },
    initialize: function initialize(options) {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.addedItems = new Backbone.Collection();
      this.addedList.collection = this.addedItems;
      this.listenTo(this.addedList, 'item:remove', function (item) {
        this.triggerMethod(this.getOption('entityName') + ':removed', item.model);
        this.addedItems.remove(item.model);
        this.fetchSrcList();
      });
      this.searchList.table.invertColumnChildViewsOnActive = true;
      var self = this;
      _.defer(function () {
        self.setupItemTable();
        self.setupSearch();
        if (self.getOption('loadAllImmediately')) {
          self.fetchSrcList();
        }
      });
    },
    fetchSrcList: function fetchSrcList() {
      var table = this.searchList.table,
        text = this.searchList.searchView.value,
        loadAllImmediately = this.getOption('loadAllImmediately'),
        allTermsMatch = this.getOption('allTermsMatch') || false,
        emptyViewOptions = table.emptyViewOptions || {},
        data = allTermsMatch ? {
          a: true,
          q: text
        } : {
          q: text
        };
      if (text || loadAllImmediately) {
        this.srcCollection.fetch({
          data: loadAllImmediately ? {} : data
        }).promise().bind(this).tap(function () {
          this.updateTableEmptyText();
          table.value = this.srcCollection.at(0);
        });
      } else {
        this.updateTableEmptyText();
        this.srcCollection.reset([]);
      }
    },
    updateTableEmptyText: function updateTableEmptyText() {
      var table = this.searchList.table,
        text = this.searchList.searchView.value,
        emptyView = table._showingEmptyView ? table.children.first() : null,
        emptyViewOptions = _.clone(table.emptyViewOptions || {});
      if (!this._tableEmptyViewOptions) {
        this._tableEmptyViewOptions = _.clone(emptyViewOptions);
      }
      if (text || this.getOption('loadAllImmediately')) {
        if (emptyView) {
          _.extend(emptyView.options, this._tableEmptyViewOptions);
        }
        table.emptyViewOptions = _.clone(this._tableEmptyViewOptions);
      } else {
        emptyViewOptions.icon = 'search';
        emptyViewOptions.text = 'Use the search box above to find records.';
        table.emptyViewOptions = emptyViewOptions;
        if (emptyView) {
          _.extend(emptyView.options, emptyViewOptions);
        }
      }
      if (emptyView) {
        emptyView.render();
      }
    },
    setupSearch: function setupSearch() {
      var search = this.searchList.searchView,
        srcCollection = this.getSrcCollection(),
        self = this;
      this.listenTo(search, 'key:code', _.debounce(this.fetchSrcList, 400));
    },
    getSrcCollection: function getSrcCollection() {
      var srcList = this.getOption('srcCollection');
      if (!srcList) {
        throw new Error('You must define srcCollection or override getSrcCollection');
      }
      return srcList;
    },
    getColumns: function getColumns() {
      return [];
    },
    setupItemTable: function setupItemTable() {
      var srcCollection = this.getSrcCollection(),
        columns = this.columns || this.getOption('columns') || this.getColumns();
      ignoreIds = _.pluck(this.options.ignore || [], 'id'), localQuery = this.getOption('localQuery'), searchList = this.searchList, self = this;
      this.srcCollection = srcCollection;
      srcCollection.addAdapter({
        filter: function filter(data) {
          var totalIdsToIgnore = ignoreIds.concat(self.addedItems.pluck('id'));
          return _.filter(data, function (p) {
            if (localQuery) {
              var text = self.searchList.searchView.value,
                keys = _.keys(p),
                found = false;
              text = text != null ? String(text).toLowerCase() : '';
              for (var i = 0, key; i < keys.length; i++) {
                key = keys[i];
                if (String(p[key]).toLowerCase().indexOf(text) > -1) {
                  found = true;
                }
              }
              ;
              if (!found) {
                return false;
              }
            }
            return _.indexOf(totalIdsToIgnore, p.id) == -1;
          });
        }
      });
      srcCollection.fetched = true;
      searchList.table.compact = false;
      searchList.table.selectable = true;
      searchList.table.selection = 'single';
      searchList.table.sortable = false;
      searchList.setupCollection(srcCollection, {
        autoFetch: true
      }).setupLoading().setupEmptyView(EmptyTableView.Row, {
        visible: true,
        text: 'No results found',
        headerTag: 'h4'
      }).setupSearch().setupColumns(FINDER_COLUMNS.slice(0).concat(columns || []));
      this.listenTo(searchList.table, 'row:double:press', this.addItemFromRowToList);
      this.listenTo(searchList.table, 'row:add', this.addItemFromRowToList);
      this.updateTableEmptyText();
    },
    addItemFromRowToList: function addItemFromRowToList(row) {
      this.triggerMethod(this.getOption('entityName') + ':added', row.model);
      this.addedItems.push(row.model);
      this.srcCollection.remove(row.model);
    }
  });
  return FinderOverlay;
});

